var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"align-center layout px-4 pt-4 app--page-header",attrs:{"row":""}},[_c('div',{staticClass:"page-header-left"},[_c('br')]),_c('v-breadcrumbs',{attrs:{"divider":"-","items":_vm.breadcrumbs}}),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }